import { LoggerConfig } from '@eng-ds/logger';

export const loggerConfig: LoggerConfig = {
  level: 0,
};
